<template>
  <div style="height:100%">
    <portal to="app-header">
      <span>{{ $t('maintenanceTask.title') }}</span>
      <v-btn icon small class="ml-4 mb-1">
        <v-icon
          v-text="'$info'"
        ></v-icon>
      </v-btn>
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            small
            v-on="on"
            v-bind="attrs"
            class="ml-2 mb-1"
            @click="refreshMaintenanceTasks"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        {{ $t('maintenanceTask.lastRefreshed') }} <strong>{{ lastRefreshedAt }}</strong>
      </v-tooltip>
    </portal>
    <task-toolbar />
    <task-drawer />
    <v-progress-linear
      :indeterminate="true"
      v-if="loading"
    ></v-progress-linear>
    <component :is="component" />
  </div>
</template>

<script>
import {
  mapState,
  mapActions,
  mapMutations,
  mapGetters,
} from 'vuex';
import TaskToolbar from '../components/TaskToolbar.vue';
import TaskDrawer from '../components/TaskDrawer.vue';
import TaskList from '../components/views/TaskList.vue';
import TaskCalendar from '../components/views/TaskCalendar.vue';

export default {
  name: 'MaintenanceTask',
  components: {
    TaskToolbar,
    TaskDrawer,
    TaskList,
    TaskCalendar,
  },
  computed: {
    ...mapState('maintenanceTask', ['loading', 'lastRefreshedAt']),
    ...mapGetters('maintenanceTask', ['isCalendarView']),
    component() {
      return this.isCalendarView
        ? 'task-calendar'
        : 'task-list';
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  created() {
    this.setExtendedHeader(true);
  },
  methods: {
    ...mapMutations('helper', ['setExtendedHeader']),
    ...mapActions('maintenanceTask', ['fetchTaskList']),
    refreshMaintenanceTasks() {
      this.fetchTaskList();
    },
    gotToSettings() {
      this.$router.push({ name: 'maintenanceTaskSettings' });
    },
  },
};
</script>
